import { createApiInstance } from "./Api";


const createStoreService = () => {

  const Api = createApiInstance();


  return {
    createStoreAsync: async (storeDetails: Record<string, any>) =>
      Api.post('/stores', storeDetails),

    getStoresAsync: async () =>
      Api.get('/stores'),

    getMyStoresAsync: async () =>
      Api.get('/stores/my-stores'),

    getStoreAsync: async (storeId: string) =>
      Api.get(`/stores/${storeId}`),

    updateStoreAsync: async (storeId: string, storeDetails: any) =>
      Api.patch(`/stores/${storeId}`, storeDetails),
    
    deleteStoreAsync: async (storeId: string) =>
      Api.delete(`/stores/${storeId}`)
  };
};

//const StoreService = createStoreService();
export default createStoreService;
